/**
 * book-identity.ts — 运营可见的书籍身份
 *
 * 界面展示书编码：语言行 `book_code`（10 位）优先，否则书组 `book_group_code`（7 位）。
 * uuid 只作内部主键，禁止当展示兜底。C 端未回传编码时返回空，调用方画「—」。
 */

/** 书籍查询入口共享提示，来源 ID 由后端精确匹配，不增加批量来源展示。 */
export const BOOK_SEARCH_PLACEHOLDER = '书名 / 作者 / 书编码 / 来源书籍 ID';

export function bookCodeText(input: {
  bookCode?: string | null;
  bookGroupCode?: string | null;
}): string | null {
  const code = input.bookCode?.trim() || input.bookGroupCode?.trim();
  return code || null;
}

export function bookCodeDisplay(input: {
  bookCode?: string | null;
  bookGroupCode?: string | null;
  locale?: string | null;
}): string {
  const code = bookCodeText(input);
  if (!code) return '—';
  return input.locale ? `${code} · ${input.locale}` : code;
}

export function bookRowCodeText(book: {
  bookGroupCode?: string | null;
  displayLocale?: string | null;
  languageCodes?: Array<{ locale: string; bookCode: string | null }>;
}): string | null {
  const loc = book.displayLocale;
  const row = loc ? book.languageCodes?.find((r) => r.locale === loc) : undefined;
  return bookCodeText({
    bookCode: row?.bookCode,
    bookGroupCode: book.bookGroupCode,
  });
}

export function bookRowMatchesQuery(
  book: {
    displayTitle?: string;
    originalTitle?: string;
    author?: string;
    bookGroupCode?: string | null;
    languageCodes?: Array<{ bookCode: string | null; title: string }>;
  },
  raw: string,
): boolean {
  const q = raw.trim().toLowerCase();
  if (!q) return true;
  if (book.displayTitle?.toLowerCase().includes(q)) return true;
  if (book.originalTitle?.toLowerCase().includes(q)) return true;
  if (book.author?.toLowerCase().includes(q)) return true;
  if (book.bookGroupCode?.toLowerCase().includes(q)) return true;
  return (
    book.languageCodes?.some(
      (row) => row.bookCode?.toLowerCase().includes(q) || row.title.toLowerCase().includes(q),
    ) ?? false
  );
}
